export const paymentType = [
    { value: 'monthly', label: 'Monthly' },
    { value: 'yearly', label: 'Yearly' }
];

export const planType = [
    {
        id: 1,
        title: {
            plan: 'Essential',
            tagline: 'Forms with a personal touch',
            price: 35
        },
        responsePerMonth: 1000,
        logicJump: 3,
        unlimitedProjects: 'Unlimited',
        unlimitedQuestions: 'Unlimited',
        mediaUpload: '2GB',
        collectPayment: true,
        CustomPage: true,
        HubspotIntegration: false,
        teamCollaboration: false,
        removeBranding: false,
        liveChat: false
    },
    {
        id: 2,
        title: {
            plan: 'Professional',
            tagline: 'More powerful, interactive forms',
            price: 35
        },
        responsePerMonth: 5000,
        logicJump: 'Unlimited',
        unlimitedProjects: 'Unlimited',
        unlimitedQuestions: 'Unlimited',
        mediaUpload: '2GB',
        collectPayment: true,
        CustomPage: true,
        HubspotIntegration: true,
        teamCollaboration: false,
        removeBranding: false,
        liveChat: false
    },
    {
        id: 3,
        title: {
            plan: 'Premium',
            tagline: 'Advanced features for brands',
            price: 70
        },
        responsePerMonth: 10000,
        logicJump: 'Unlimited',
        unlimitedProjects: 'Unlimited',
        unlimitedQuestions: 'Unlimited',
        mediaUpload: '4GB',
        collectPayment: true,
        CustomPage: true,
        HubspotIntegration: true,
        teamCollaboration: true,
        removeBranding: true,
        liveChat: true
    }
];

export const planColumns = [
    { header: 'Responses per month', name: 'responsePerMonth' },
    { header: 'Logic jump per project', name: 'logicJump' },
    { header: 'Unlimited projects', name: 'unlimitedProjects' },
    { header: 'Unlimited questions', name: 'unlimitedQuestions' },
    { header: 'Media upload', name: 'mediaUpload' },
    { header: 'Collect payments', name: 'collectPayment' },
    { header: 'Custom thank you page', name: 'CustomPage' },
    { header: 'Hubspot integration', name: 'HubspotIntegration' },
    { header: 'Team collaboration', name: 'teamCollaboration' },
    { header: 'Remove branding', name: 'removeBranding' },
    { header: 'Priority support and live chat', name: 'liveChat' }
];

export const PROVINCE_CODE = [
    {
        label: 'Northwest Territories',
        value: 'NT'
    },
    { label: 'Nunavut', value: 'NU' },
    {
        label: 'Nova Scotia',
        value: 'NS'
    },
    {
        label: 'British Columbia',
        value: 'BC'
    },
    {
        label: 'Saskatchewan',
        value: 'SK'
    },
    {
        label: 'Prince Edward Island',
        value: 'PE'
    },
    {
        label: 'Manitoba',
        value: 'MB'
    },
    { label: 'Yukon', value: 'YT' },
    {
        label: 'New Brunswick',
        value: 'NB'
    },
    {
        label: 'Newfoundland and Labrador',
        value: 'NL'
    },
    { label: 'Ontario', value: 'ON' },
    { label: 'Alberta', value: 'AB' },
    { label: 'Quebec', value: 'QC' }
];

export const COUNTRY_CODE = [{ label: 'Canada', value: 'CA' }];
